import React from 'react'

const GraphLabel2 = ({color, value}) => {
  return (
    <div
    className="graph_name G-name"
    style={{ paddingLeft: "60px", width: "92%" }}
  >
    <span
      style={{ backgroundColor: `${color[0]}` }}
      className="indicator"
    ></span>
    <h5 style={{ paddingLeft: "5px" }} className="ind-text">
      {value[0]}
    </h5>
    <span
      style={{ backgroundColor: `${color[1]}`}}
      className="indicator"
    ></span>
    <h5 style={{ paddingLeft: "5px" }} className="ind-text">
      {value[1]}
    </h5>
  </div>
  )
}

export default GraphLabel2
